/**
 * @generated SignedSource<<c7879052d0780a086aee59a4e42a9169>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_user" | "PdpSharedSocialShareEmail_user">;
  readonly " $fragmentType": "PdpRespIconBubbles_user";
};
export type PdpRespIconBubbles_user$key = {
  readonly " $data"?: PdpRespIconBubbles_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareEmail_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbleShare_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ea8e862adaa6acbddcf35c75f2941993";

export default node;
